/*
 * Runway Hair UK - On the shelf carousel
 * Infinite loop: the card set is cloned either side and the scroll position is
 * silently repositioned when you cross a boundary, so next/prev never run out.
 * Falls back to a plain arrows-with-ends carousel when looping is switched off.
 */
(function () {
  'use strict';

  function initOne(root) {
    if (root.dataset.shelfReady === '1') return;
    var track = root.querySelector('[data-shelf-track]');
    var prev = root.querySelector('[data-shelf-prev]');
    var next = root.querySelector('[data-shelf-next]');
    if (!track || !prev || !next) return;

    var wantLoop = root.dataset.shelfLoop === 'true';
    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    root.dataset.shelfReady = '1';

    var looping = false;
    var setWidth = 0;

    function gapPx() {
      var cs = window.getComputedStyle(track);
      return parseFloat(cs.columnGap || cs.gap) || 0;
    }

    function measureSet() {
      var gap = gapPx();
      var w = 0;
      for (var i = 0; i < originals.length; i++) {
        w += originals[i].offsetWidth + gap;
      }
      return w;
    }

    function pageStep() {
      var card = originals[0];
      if (!card || !card.offsetWidth) return track.clientWidth;
      var gap = gapPx();
      var unit = card.offsetWidth + gap;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / unit));
      return per * unit;
    }

    function hardScrollTo(x) {
      var sb = track.style.scrollBehavior;
      var sn = track.style.scrollSnapType;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.scrollLeft = x;
      void track.offsetWidth;
      track.style.scrollSnapType = sn;
      track.style.scrollBehavior = sb;
    }

    function addClones() {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      for (var i = 0; i < originals.length; i++) {
        var a = originals[i].cloneNode(true);
        var b = originals[i].cloneNode(true);
        a.setAttribute('aria-hidden', 'true');
        b.setAttribute('aria-hidden', 'true');
        a.setAttribute('tabindex', '-1');
        b.setAttribute('tabindex', '-1');
        a.dataset.shelfClone = '1';
        b.dataset.shelfClone = '1';
        before.appendChild(a);
        after.appendChild(b);
      }
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
    }

    function recentre() {
      if (!looping || !setWidth) return;
      var x = track.scrollLeft;
      if (x < setWidth * 0.5) {
        hardScrollTo(x + setWidth);
      } else if (x > setWidth * 1.5) {
        hardScrollTo(x - setWidth);
      }
    }

    function syncEnds() {
      if (looping) {
        prev.disabled = false;
        next.disabled = false;
        return;
      }
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    function setup() {
      setWidth = measureSet();
      var overflows = setWidth > track.clientWidth + 4;

      if (wantLoop && overflows && !looping) {
        addClones();
        looping = true;
        setWidth = measureSet();
        hardScrollTo(setWidth);
      }
      syncEnds();
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -pageStep(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: pageStep(), behavior: 'smooth' });
    });

    var settle;
    track.addEventListener('scroll', function () {
      window.clearTimeout(settle);
      settle = window.setTimeout(function () {
        recentre();
        syncEnds();
      }, 130);
    }, { passive: true });

    var rt;
    window.addEventListener('resize', function () {
      window.clearTimeout(rt);
      rt = window.setTimeout(function () {
        setWidth = measureSet();
        syncEnds();
      }, 200);
    });

    setup();
    // Widths can settle late (fonts, images). Re-measure shortly after.
    window.setTimeout(setup, 400);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-shelf-root]');
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
    document.addEventListener('DOMContentLoaded', initAll);
  }

  // Shopify theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', initAll);
}());
